import type { FormDataOf } from '../../../../../types/templates';
import { disneyESPNLogoVsLogo } from '..';

type FormData = FormDataOf<typeof disneyESPNLogoVsLogo>;

export const computeDefaults = (_formData: FormData, _resolutionId?: string): Partial<FormData> => {
  return {
    'league-logo-data': '',
    'local-shield-data': '',
    'visitor-shield-data': '',
    'local-color': '',
    'visitor-color': ''
  } as unknown as Partial<FormData>;
};
